'use strict';

const $ = require('jquery');

$(document).ready(function() {
    $('body').addClass('active');
});
